import { RoleActiveTools } from '@/components/ai/RoleActiveTools';

/**
 * Sponsor Tools Tab — Dashboard integration
 * Uses the universal RoleActiveTools + DynamicToolRunner system.
 * Same look as teacher/prospect/coach tool pages.
 */
export function SponsorToolsTab() {
  return (
    <RoleActiveTools
      role="sponsor"
      title="Your Tools"
      description="Launch your active AI tools for drafting, analysis, and business intelligence."
      marketplacePath="/sponsor/dashboard/ai-marketplace"
      showComingSoon={true}
    />
  );
}
